import React, { useState, useEffect, useRef } from 'react';
import lo from '../../assets/img/lo.png';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  ChakraProvider,
  Button,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { Login } from '../../components/other/login/login';
import { Link } from 'react-router-dom';
import Windows_height_width from '../../components/windows_height_width';
import { AiOutlineCalculator } from "react-icons/ai";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import search_one from '../../assets/img/search_one.png';
import CartIcon from '../../assets/ioon/cart.png';
import wish from '../../assets/ioon/wish.png';
import { Wishcount } from '../../redux/actions/productAction';

export default function Header() {
  const [products, setProducts] = useState([]);
const [specifications, setSpecifications] = useState([]);
const productRef = useRef(null);
const specRef = useRef(null);
const genRef = useRef(null);

const [selectedProduct, setSelectedProduct] = useState(null);
const [selectedSpec, setSelectedSpec] = useState(null);

const [productSearch, setProductSearch] = useState('');
const [specSearch, setSpecSearch] = useState('');

const [showProductDropdown, setShowProductDropdown] = useState(false);
const [showSpecDropdown, setShowSpecDropdown] = useState(false);
const [noMatchMsg, setNoMatchMsg] = useState('');


const [gens, setGens] = useState([]);
const [selectedGen, setSelectedGen] = useState(null);
const [genSearch, setGenSearch] = useState('');
const [showGenDropdown, setShowGenDropdown] = useState(false);

  const [search, setSearch] = useState('');
  const { isOpen: isCalculatorOpen, onOpen: openCalculator, onClose: closeCalculator } = useDisclosure();
  const [noo, setNo] = useState(0);
  const [wishcountss, setWishcount] = useState(0);

  const [calculatorData, setCalculatorData] = useState({
    numberOfItems: 1,
    rentalMonths: 12,
    selectedConfig: null,
    configurations: []
  });

  const [configSearch, setConfigSearch] = useState('');
  const configDropdownRef = useRef(null);

  let navigate = useNavigate();
  const product = useSelector((state) => state);
  let dispatch = useDispatch();
  let locatinon = useLocation();

  // Derived calculations
const calculations = (() => {
  if (!calculatorData.selectedConfig) {
    return {
      approximateRental: 0,
      purchaseCost: 0,
      maintenanceCost: 0,
      depreciationAmount: 0
    };
  }

  const monthlyRent = Number(calculatorData.selectedConfig.ProSpecificMonthly) || 0;
  const purchaseUnitCost = Number(calculatorData.selectedConfig.PurchaseCost) || 0;

  const qty = calculatorData.numberOfItems;
  const months = calculatorData.rentalMonths;

  const totalRentalCost = monthlyRent * qty * months;
  const totalPurchaseCost = purchaseUnitCost * qty;
  const maintenanceCost = Math.round(totalRentalCost * 0.10);
  const depreciationAmount = Math.round(totalPurchaseCost * 0.05);

  return {
    approximateRental: totalRentalCost,
    purchaseCost: totalPurchaseCost,
    maintenanceCost,
    depreciationAmount
  };
})();


  const handleCalcChange = (field, value) => {
    const updated = { ...calculatorData, [field]: value };
    setCalculatorData(updated);
  };

  const filteredConfigs = calculatorData.configurations.filter(config =>
    config.ProSpecificName.toLowerCase().includes(configSearch.toLowerCase())
  );

  const selectConfig = (config) => {
    handleCalcChange('selectedConfig', config);
    setConfigSearch('');
  };

  const { height, width } = Windows_height_width();
  const [wi, setWi] = useState();
  const [login, setlogin] = useState(false);

  useEffect(() => {
    if (width > 1850) setWi(width - 400);
    else if (width > 1630) setWi(width - 200);
    else if (width > 1440) setWi(width);
  }, [width]);

  useEffect(() => {
    const stor = localStorage.getItem('user_data');
    setlogin(stor !== null);
  }, []);

  const searchClicked = () => {
    if (!search.trim()) return;
    localStorage.setItem('search', search);
    navigate('/search');
  };

  const enterKey = (e) => {
    if (e.key === 'Enter') searchClicked();
  };

  // Fetch configurations
  // useEffect(() => {
  //   if (!isCalculatorOpen) return;

  //   fetch("https://rentla.in/rentlanewmodule/api/ve2/fetchConfig", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" }
  //   })
  //     .then(res => res.json())
  //     .then(json => {
  //       if (json.status && json.data) {
  //         setCalculatorData(prev => ({
  //           ...prev,
  //           configurations: json.data,
  //           selectedConfig: null
  //         }));
  //       }
  //     })
  //     .catch(err => console.error("Config fetch error:", err));
  // }, [isCalculatorOpen]);

  useEffect(() => {
  if (!isCalculatorOpen) return;

  fetch("https://rentla.in/rentlanewmodule/api/ve2/proList", {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  })
    .then(res => res.json())
    .then(json => {
      if (json.status) {
        setProducts(json.data || []);
      }
    });
}, [isCalculatorOpen]);
useEffect(() => {
  if (!isCalculatorOpen) return;

  fetch("https://rentla.in/rentlanewmodule/api/ve2/specList", {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  })
    .then(res => res.json())
    .then(json => {
      if (json.status) {
        setSpecifications(json.data || []);
        setSelectedSpec(null);
        setSpecSearch('');
      }
    });
}, [isCalculatorOpen]);
useEffect(() => {
  if (!isCalculatorOpen) return;

  fetch("https://rentla.in/rentlanewmodule/api/ve2/genList", {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  })
    .then(res => res.json())
    .then(json => {
      if (json.status) {
        setGens(json.data || []);
        setSelectedGen(null);
        setGenSearch('');
      }
    });
}, [isCalculatorOpen]);
const filteredGens = (gens || []).filter(g =>
  (g.GenName || '').toLowerCase().includes(genSearch.toLowerCase())
);


const filteredProducts = (products || []).filter(p =>
  (p.InventoryCatName || '')
    .toLowerCase()
    .includes(productSearch.toLowerCase())
);

const filteredSpecs = (specifications || []).filter(spec =>
  (spec.ProSpecificName || '')
    .toLowerCase()
    .includes(specSearch.toLowerCase())
);

  // Cart & Wishlist counts
  useEffect(() => {
    const wishss = localStorage.getItem('data');
    const widata = localStorage.getItem('wish_list');

    if (widata) {
      const hiis = JSON.parse(widata);
      setWishcount(hiis.length || 0);
      dispatch(Wishcount(hiis));
    } else {
      setWishcount(0);
    }

    if (wishss) {
      const hii = JSON.parse(wishss);
      setNo(hii.length || 0);
    } else {
      setNo(0);
    }
  }, []);

  useEffect(() => {
    if (product.wishcount?.products?.length >= 0) {
      setWishcount(product.wishcount.products.length);
    }
  }, [product]);

useEffect(() => {
  if (!selectedProduct || !selectedGen || !selectedSpec) {
    setNoMatchMsg('');
    handleCalcChange('selectedConfig', null);
    return;
  }

  fetch("https://rentla.in/rentlanewmodule/api/ve2/fetchAmount", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      processor_name: selectedProduct.InventoryCatName,
      gen_id: selectedGen.GenID,
      specification_name: selectedSpec.ProSpecificName
    })
  })
    .then(res => res.json())
    .then(json => {
      if (json.status && json.data) {
        setNoMatchMsg('');
        handleCalcChange('selectedConfig', {
          PurchaseCost: json.data.PurchaseCost,
          ProSpecificMonthly: json.data.MonthlyRent
        });
      } else {
        // 👇 NO MATCH
        setNoMatchMsg('No records available for this combination');
        handleCalcChange('selectedConfig', null);
      }
    })
    .catch(() => {
      setNoMatchMsg('Something went wrong. Try again.');
      handleCalcChange('selectedConfig', null);
    });

}, [selectedProduct, selectedGen, selectedSpec]);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (productRef.current && !productRef.current.contains(e.target)) {
      setShowProductDropdown(false);
    }
    if (specRef.current && !specRef.current.contains(e.target)) {
      setShowSpecDropdown(false);
    }
    if (genRef.current && !genRef.current.contains(e.target)) {
      setShowGenDropdown(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);



  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <>
      <header className="header-area clearfix header-hm9 transparent-bar">
        <div className='container head_containers'>
          <div className="header-top-area">
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2 col-12 col-xxl-2">
                <div style={{ width: '115px' }} className="logo-hm9 text-center">
                  <Link to='/'>
                    <img className='hdddimggg' alt="logo" src={lo} />
                  </Link>
                </div>
              </div>

              <div className="col-lg-8 col-md-8 col-sm-5 col-xxl-8"></div>

              <div className="col-lg-2 col-md-2 col-sm-2 col-12 col-xxl-2">
                <div className="header-right-wrap">
                  <div className="same-style header-search">
                    <div className="search-container">
                      <div className='d-flex justify-content-start'>
                        <input
                          onKeyDown={enterKey}
                          onChange={(e) => e.target.value !== ' ' && setSearch(e.target.value)}
                          value={search}
                          className='head_search'
                          type="text"
                          placeholder="Laptops, Workstation, Pc, Etc..."
                        />
                        <img onClick={searchClicked} className='head_search_img' src={search_one} alt="search" />
                      </div>
                    </div>
                  </div>

                  <div className="same-style account-satting"><Login /></div>

                  {/* <div className="same-style cart-wrap">
                    <div className="calculator-wrap">
                      <AiOutlineCalculator
                        size={28}
                        className="head_search_imgs"
                        style={{ cursor: 'pointer' }}
                        title="Calculator"
                        onClick={openCalculator}
                      />
                    </div>
                  </div> */}


                  <div className="same-style cart-wrap">
                    <Link to='/cart'>
                      <img style={{ width: 30 }} src={CartIcon} className='head_search_imgs' alt="cart" />
                      <span className='badge badge-warning' id='lblCartCount'>{noo}</span>
                    </Link>
                  </div>

                  <div className="same-style header-wishlist">
                    <Link to="/wish">
                      <img style={{ width: 30 }} src={wish} className='head_search_imgs' alt="wishlist" />
                      <span className='badge badge-warning' id='lblCartCount'>{wishcountss}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Floating ROI Button */}
<div
  className="roi-float-btn blink"
  onClick={openCalculator}
  title="ROI Calculator"
>
  ROI
</div>
      </header>
       <style>
{`
  .roi-float-btn {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #f4b644;

    color: #000;
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 9999;
    box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  }

  .blink {
    animation: pulse 1.6s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(244,182,68,0.7);
    }
    70% {
      transform: scale(1.1);
      box-shadow: 0 0 0 18px rgba(244,182,68,0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(244,182,68,0);
    }
  }
`}
</style>

      {/* Calculator Modal */}
      {isCalculatorOpen && (
        <div
  className="custom-modal-overlay"
  onClick={closeCalculator}
  style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px'
  }}
>
          <div
  className="custom-modal-content"
  onClick={(e) => e.stopPropagation()}
  style={{
    width: '100%',
    maxWidth: '520px',
    height: '100%',
    maxHeight: '92vh',
    background: '#fff',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }}
>

            <div
  className="custom-modal-header"
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: '#fff',
    padding: '16px',
    borderBottom: '1px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}
>

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {/* <div style={{ width: '32px', height: '32px', backgroundColor: '#f4b644', borderRadius: '50%' }} /> */}
                <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                  Rental vs Purchase Calculator
                </h3>
              </div>
              <button
                onClick={closeCalculator}
                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}
              >
                ×
              </button>
            </div>

            <div
  className="custom-modal-body"
  style={{
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    WebkitOverflowScrolling: 'touch'
  }}
>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                {/* Number of Laptops */}
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Number of Laptops
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                    <button onClick={() => handleCalcChange('numberOfItems', Math.max(1, calculatorData.numberOfItems - 1))}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>−</button>
                    <input
                      type="number"
                      value={calculatorData.numberOfItems}
                      onChange={(e) => handleCalcChange('numberOfItems', Math.max(1, parseInt(e.target.value) || 1))}
                      style={{ padding: '12px', textAlign: 'center', border: 'none', width: '100%', fontSize: '18px' }}
                      min="1"
                    />
                    <button onClick={() => handleCalcChange('numberOfItems', calculatorData.numberOfItems + 1)}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>+</button>
                  </div>
                </div>

                {/* Rental Months */}
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Rental Months
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                    <button onClick={() => handleCalcChange('rentalMonths', Math.max(1, calculatorData.rentalMonths - 1))}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>−</button>
                    <input
                      type="number"
                      value={calculatorData.rentalMonths}
                      onChange={(e) => handleCalcChange('rentalMonths', Math.max(1, parseInt(e.target.value) || 1))}
                      style={{ padding: '12px', textAlign: 'center', border: 'none', width: '100%', fontSize: '18px' }}
                      min="1"
                      max="60"
                    />
                    <button onClick={() => handleCalcChange('rentalMonths', calculatorData.rentalMonths + 1)}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>+</button>
                  </div>
                </div>

                {/* Searchable Configuration Dropdown */}
                {/* <div style={{ gridColumn: 'span 2' }} ref={configDropdownRef}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Configuration
                  </label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      placeholder={calculatorData.selectedConfig ? calculatorData.selectedConfig.ProSpecificName : "Search configuration..."}
                      value={configSearch}
                      onChange={(e) => setConfigSearch(e.target.value)}
                      onFocus={() => setConfigSearch('')}
                      style={{
                        width: '100%',
                        padding: '14px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '16px',
                        background: calculatorData.selectedConfig ? '#f0fdf4' : 'white'
                      }}
                    />
                    {filteredConfigs.length > 0 && configSearch && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        background: 'white',
                        border: '2px solid #e2e8f0',
                        borderTop: 'none',
                        borderRadius: '0 0 8px 8px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        zIndex: 10
                      }}>
                        {filteredConfigs.map((config, index) => (
                          <div
                            key={index}
                            onClick={() => selectConfig(config)}
                            style={{
                              padding: '12px 16px',
                              cursor: 'pointer',
                              borderBottom: index < filteredConfigs.length - 1 ? '1px solid #e2e8f0' : 'none',
                              background: 'white',
                              ':hover': { background: '#f7fafc' }
                            }}
                          >
                            <div style={{ fontWeight: '500' }}>{config.ProSpecificName}</div>
                            <div style={{ fontSize: '14px', color: '#f4b644' }}>₹{config.ProSpecificMonthly}/month</div>
                          </div>
                        ))}
                      </div>
                    )}
                    {configSearch && filteredConfigs.length === 0 && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        padding: '12px',
                        background: 'white',
                        border: '2px solid #e2e8f0',
                        borderTop: 'none',
                        borderRadius: '0 0 8px 8px',
                        color: '#718096'
                      }}>
                        No configurations found
                      </div>
                    )}
                  </div>
                  {calculatorData.selectedConfig && !configSearch && (
                    <div style={{ marginTop: '8px', fontSize: '14px', color: '#f4b644', fontWeight: '500' }}>
                      Selected: {calculatorData.selectedConfig.ProSpecificName} — ₹{calculatorData.selectedConfig.ProSpecificMonthly}/month
                    </div>
                  )}
                </div> */}

      <div style={{ gridColumn: 'span 2' }}>
  <label style={{ fontWeight: 500 }} >Processors</label>

  <div style={{ position: 'relative' }} ref={productRef}>
    <input
      type="text"
      placeholder="Select processor"
      value={
        showProductDropdown
          ? productSearch
          : selectedProduct?.InventoryCatName || ''
      }
      onFocus={() => {
        setShowProductDropdown(true);
        setProductSearch('');
      }}
      onChange={(e) => {
        setProductSearch(e.target.value);
        setShowProductDropdown(true);
      }}
      style={{
        width: '100%',
        padding: '14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px'
      }}
    />

    {showProductDropdown && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #e2e8f0',
          maxHeight: '220px',
          overflowY: 'auto',
          zIndex: 50
        }}
      >
        {filteredProducts.length > 0 ? (
          filteredProducts.map((p) => (
            <div
              key={p.InventoryCatName}
              onClick={() => {
                setSelectedProduct(p);
                setShowProductDropdown(false);
              }}
              style={{
                padding: '12px',
                cursor: 'pointer'
              }}
            >
              {p.InventoryCatName}
            </div>
          ))
        ) : (
          <div style={{ padding: '12px', color: '#999' }}>
            No processors found
          </div>
        )}
      </div>
    )}
  </div>
</div>

<div style={{ gridColumn: 'span 2' }}>
  <label style={{ fontWeight: 500 }}>Specification</label>

  <div style={{ position: 'relative' }} ref={specRef}>
    <input
      type="text"
      placeholder="Select specification"
      
      value={
        showSpecDropdown
          ? specSearch
          : selectedSpec
          ? `${selectedSpec.ProSpecificName}`
          : ''
      }
      onFocus={() => {
        setShowSpecDropdown(true);
        setSpecSearch('');
      }}
      onChange={(e) => {
        setSpecSearch(e.target.value);
        setShowSpecDropdown(true);
      }}
      style={{
        width: '100%',
        padding: '14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        background:  '#fff'
      }}
    />

    {showSpecDropdown && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #e2e8f0',
          maxHeight: '220px',
          overflowY: 'auto',
          zIndex: 50
        }}
      >
        {filteredSpecs.length > 0 ? (
          filteredSpecs.map((s) => (
            <div
              key={s.ProSpecificId}
              onClick={() => {
                  setSelectedSpec(s);
                  setShowSpecDropdown(false);
                  setSpecSearch('');
                }}
              style={{ padding: '12px', cursor: 'pointer' }}
            >
              <div style={{ fontWeight: 500 }}>
                {s.ProSpecificName}
              </div>
             
            </div>
          ))
        ) : (
          <div style={{ padding: '12px', color: '#999' }}>
            No specifications found
          </div>
        )}
      </div>
    )}
  </div>
</div>

<div style={{ gridColumn: 'span 2' }}>
  <label style={{ fontWeight: 500 }}>Generation</label>

  <div style={{ position: 'relative' }} ref={genRef}>
    <input
      type="text"
      placeholder="Select generation"
      
      value={
        showGenDropdown
          ? genSearch
          : selectedGen?.GenName || ''
      }
      onFocus={() => {
        setShowGenDropdown(true);
        setGenSearch('');
      }}
      onChange={(e) => {
          setGenSearch(e.target.value);
          setShowGenDropdown(true);
        }}
      style={{
        width: '100%',
        padding: '14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        background: '#fff' 
      }}
    />

    {showGenDropdown  && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #e2e8f0',
          maxHeight: '220px',
          overflowY: 'auto',
          zIndex: 50
        }}
      >
        {filteredGens.length > 0 ? (
          filteredGens.map((g) => (
            <div
              key={g.GenName}
              onClick={() => {
                setSelectedGen(g);
                handleCalcChange('selectedConfig', null);
                setShowGenDropdown(false);
              }}
              style={{ padding: '12px', cursor: 'pointer' }}
            >
              {g.GenName}
            </div>
          ))
        ) : (
          <div style={{ padding: '12px', color: '#999' }}>
            No generations found
          </div>
        )}
      </div>
    )}
  </div>
</div>

{noMatchMsg && (
  <div
    style={{
      gridColumn: 'span 2',
      padding: '12px',
      background: '#fff5f5',
      border: '1px solid #feb2b2',
      color: '#c53030',
      borderRadius: '8px',
      fontWeight: 500
    }}
  >
    {noMatchMsg}
  </div>
)}



                {/* Estimated Costs - 2x2 Grid */}
                <div style={{ gridColumn: 'span 2' }}>
                  <h4 style={{ marginBottom: '16px', color: '#4a5568' }}>Estimated Costs</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Total Rental Cost</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#f4b644' }}>
                        ₹{calculations.approximateRental.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Purchase Cost</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#3182ce' }}>
                        ₹{calculations.purchaseCost.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Maintenance Cost</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#38a169' }}>
                        ₹{calculations.maintenanceCost.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Depreciation (1st Year)</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#e53e3e' }}>
                        ₹{calculations.depreciationAmount.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           <div
  className="custom-modal-footer"
  style={{
    position: 'sticky',
    bottom: 0,
    background: '#fff',
    padding: '16px',
    borderTop: '1px solid #e2e8f0',
    zIndex: 10
  }}
>

              <button
                onClick={closeCalculator}
                style={{
                  padding: '12px 32px',
                  backgroundColor: '#f4b644',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              >
                Close Calculator
              </button>
            </div>
          </div>
        </div>
      )}

      <ChakraProvider>
        <Drawer isOpen={isOpen} placement='right' onClose={onClose} finalFocusRef={btnRef}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Shopping Cart</DrawerHeader>
            <DrawerBody>{/* Cart items here */}</DrawerBody>
            <DrawerFooter>
              <Button variant='outline' mr={3} onClick={onClose}>Cancel</Button>
              <Button style={{ backgroundColor: '#F4B644', color: 'white' }}>View Cart</Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      </ChakraProvider>
    </>
  );
 

}